/**
 * Utility Noop functions to provide a disabled void function to call
 */
export type Noop = () => void
export const noop: Noop = () => {}
export const noopAsync: Promise<void> = new Promise((resolve) => {
  resolve()
})
